import DeleteConfirmationModal from './deleteConfirmationModal';

export default DeleteConfirmationModal;
